<template>
<div container--fluid>
    <v-layout>
        <BookingModule></BookingModule>
    </v-layout>
</div>
</template>

<script>
import BookingModule from '@modules/booking/mybookings.vue';

export default {
    name: 'mybooking',
    components: {
        BookingModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
